import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { UIComponentHandler, UIComponentImpl, UIComponentProps, UIComponentState, UIDataModel } from '../../../uicomponent';
import { UIComponentCSSStyle } from '../../../uicomponentcss';
import { UIComponentView } from '../../../uicomponentview';
import { SearchBoxToneOptionCSSStyleImpl } from './searchboxtoneoptioncss';
import { SearchBoxToneOptionViewImpl } from './searchboxtoneoptionview';
import { DropDownDto, DropDownDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/dropdown/dropdowndto';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';

export interface SearchBoxToneOptionComponentProps extends UIComponentProps
{
    searchKey: string;
    type: string;
    // cssStyle:SearchBoxCSSStyle;
    onSearchBoxButtonClicked(searchKey: string,type:string):void;
}

export interface SearchBoxToneOptionComponentHandler extends UIComponentHandler
{
    onSearchBoxButtonClicked(searchKey: string):void;
    onChange(value: string): void;
    onDropdownOptionClick(isShow:boolean,searchKey:string):void;
    onTypeChange(isChecked: boolean,id:string, type:string): void;

    // clearData():void;
}

export interface SearchBoxToneOptionComponentState extends UIComponentState
{
    searchKey: string;
    isSearchOptionSelected:boolean;
    defaultOption:string;
    defaultOptionId: string;
    errorMessage: undefined | string;
}

export class SearchBoxToneOptionComponent extends UIComponentImpl<SearchBoxToneOptionComponentProps, SearchBoxToneOptionComponentState, UIDataModel> implements SearchBoxToneOptionComponentHandler
{
    private optionsList: DropDownDto[];

    constructor(props: SearchBoxToneOptionComponentProps,state:SearchBoxToneOptionComponentState)
    {
        super(props);

        this.optionsList = this.getDropdownList();
        this.state = {searchKey: props.searchKey,isSearchOptionSelected:false,
            defaultOptionId: props.type, defaultOption: this.getTypeBasedonId(props.type), errorMessage: undefined};
    }
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new SearchBoxToneOptionViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new SearchBoxToneOptionCSSStyleImpl(applicationContext);
    }

    componentDidMount()
    {
        // let index = this.optionsList.findIndex((value: DropDownDto) =>
        // {
        //     return value.getId() === this.props.type;
        // });

        // if(index === -1)
        // {
        //     this.setErrorMessage(this.getContext().getResources().getString(Strings.invalid_search_type));
        // }
    }

    setErrorMessage(errorMesssage: string)
    {
        this.setState({errorMessage: errorMesssage});
    }
    validate(): boolean
    {
        if(this.state.searchKey.length === 0)
        {
            this.setState({errorMessage: this.getContext().getResources().getString(Strings.invalid_searchKey)});

            return false;
        }
        else
        {
            this.setState({errorMessage: undefined});

            return true;
        }
    }

    componentWillReceiveProps(nextProps: SearchBoxToneOptionComponentProps)
    {
        this.setState({searchKey: nextProps.searchKey});
    }

    onSearchBoxButtonClicked(searchKey: string): void 
    {
        this.props.onSearchBoxButtonClicked(searchKey, this.state.defaultOptionId);
    }   

    onChange(value: string): void {
        this.setState({searchKey: value});
    }
    clearData():void
    {
        this.setState({searchKey:"", errorMessage: undefined});
    }
    onDropdownOptionClick(isShow: boolean): void 
    {
        this.setState({isSearchOptionSelected: isShow});
    }

    
    
    getDropdownList():DropDownDto[]
    {
        let dropdown1 = new DropDownDtoImpl();
        dropdown1.setTitle(this.getContext().getResources().getString(Strings.Song));
        dropdown1.setId(this.getContext().getResources().getString(Strings.song));
        let dropdown2 = new DropDownDtoImpl();
        dropdown2.setTitle(this.getContext().getResources().getString(Strings.Singer));
        dropdown2.setId(this.getContext().getResources().getString(Strings.singer));
        let dropdown3 = new DropDownDtoImpl();
        dropdown3.setTitle(this.getContext().getResources().getString(Strings.Code));
        dropdown3.setId(this.getContext().getResources().getString(Strings.code));
        
        return [dropdown1, dropdown2, dropdown3];
    }

    onTypeChange(isChecked: boolean,id:string, type:string):void
    {
        this.setState({defaultOption: type, defaultOptionId:id, isSearchOptionSelected:isChecked, errorMessage: undefined});
        
    }

    private getTypeBasedonId(id: string)
    {
        let dropdowndto = this.optionsList.find((value: DropDownDto) =>
        {
            return value.getId() === id;
        });

        return dropdowndto !== undefined ? dropdowndto.getTitle()
         : this.getContext().getResources().getString(Strings.Song);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/toolbarwithsearch/searchbox/searchboxtoneoption/searchboxtoneoptioncomponent.tsx